import { useState } from 'react'
import Itens from './pages/Itens'
import Arranjos from './pages/Arranjos'
import Categorias from './pages/Categorias'
import Cestos from './pages/Cestos'
import Fornecedores from './pages/Fornecedores'
import Entradas from './pages/Entradas'
import Pedidos from './pages/Pedidos'
import Financeiro from './pages/Financeiro'
import './App.css'

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    if (usuario.toUpperCase() === 'BRUNA' && senha === 'Sara@123') {
      onLogin()
    } else {
      setErro('Usuário ou senha incorretos')
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo">
          <span className="logo-icon">❀</span>
          <div className="logo-name">Flor de Sarah</div>
          <div className="logo-sub">gestão de arranjos</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Usuário</label>
            <input
              value={usuario}
              onChange={e => { setUsuario(e.target.value.toUpperCase()); setErro('') }}
              autoComplete="username"
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="field">
            <label>Senha</label>
            <input
              type="password"
              value={senha}
              onChange={e => { setSenha(e.target.value); setErro('') }}
              autoComplete="current-password"
            />
          </div>
          {erro && <div className="login-erro">{erro}</div>}
          <button type="submit" className="btn btn-primary">Entrar</button>
        </form>
      </div>
    </div>
  )
}

function Drawer({ open, onClose, onNavigate, onSair }) {
  return (
    <>
      {open && <div className="drawer-overlay" onClick={onClose} />}
      <div className={`drawer ${open ? 'drawer-open' : ''}`}>
        <div className="drawer-header">
          <span className="logo-icon" style={{ fontSize: 22 }}>❀</span>
          <span className="logo-name">Flor de Sarah</span>
          <button className="drawer-close" onClick={onClose}>×</button>
        </div>
        <div className="drawer-menu">
          <button className="drawer-item" onClick={() => onNavigate('pedidos')}>
            <span className="drawer-item-icon">🛒</span>
            <span>Vendas</span>
          </button>
          <button className="drawer-item" onClick={() => onNavigate('entradas')}>
            <span className="drawer-item-icon">📦</span>
            <span>Entradas</span>
          </button>
          <button className="drawer-item" onClick={() => onNavigate('financeiro')}>
            <span className="drawer-item-icon">R$</span>
            <span>Financeiro</span>
          </button>
          <button className="drawer-item" onClick={() => onNavigate('fornecedores')}>
            <span className="drawer-item-icon">🏪</span>
            <span>Fornecedores</span>
          </button>
          <button className="drawer-item" onClick={() => onNavigate('categorias')}>
            <span className="drawer-item-icon">🏷️</span>
            <span>Categorias</span>
          </button>
        </div>
        <div className="drawer-footer">
          <button className="drawer-item drawer-sair" onClick={onSair}>
            <span className="drawer-item-icon">🚪</span>
            <span>Sair</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default function App() {
  const [logado, setLogado] = useState(() => localStorage.getItem('flor_auth') === 'ok')
  const [tab, setTab] = useState('arranjos')
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (!logado) return <Login onLogin={() => { localStorage.setItem('flor_auth', 'ok'); setLogado(true) }} />

  function navegar(novaTab) {
    setTab(novaTab)
    setDrawerOpen(false)
  }

  return (
    <div className="app">
      <header className="header">
        <div className="logo">
          <span className="logo-icon">❀</span>
          <div>
            <div className="logo-name">Flor de Sarah</div>
            <div className="logo-sub">gestão de produtos</div>
          </div>
        </div>
        <button className="menu-btn" onClick={() => setDrawerOpen(true)}>
          <span /><span /><span />
        </button>
      </header>

      <main className="main">
        {tab === 'arranjos' && <Arranjos />}
        {tab === 'itens' && <Itens />}
        {tab === 'cestos' && <Cestos />}
        {tab === 'categorias' && <Categorias />}
        {tab === 'fornecedores' && <Fornecedores />}
        {tab === 'entradas' && <Entradas />}
        {tab === 'pedidos' && <Pedidos />}
        {tab === 'financeiro' && <Financeiro />}
      </main>

      <nav className="bottom-nav">
        <button className={`nav-btn ${tab === 'arranjos' ? 'active' : ''}`} onClick={() => setTab('arranjos')}>
          <span className="nav-icon">💐</span>
          <span>Produtos</span>
        </button>
        <button className={`nav-btn ${tab === 'cestos' ? 'active' : ''}`} onClick={() => setTab('cestos')}>
          <span className="nav-icon">🧺</span>
          <span>Cestos</span>
        </button>
        <button className={`nav-btn ${tab === 'itens' ? 'active' : ''}`} onClick={() => setTab('itens')}>
          <span className="nav-icon">🌿</span>
          <span>Itens</span>
        </button>
      </nav>

      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onNavigate={navegar}
        onSair={() => { localStorage.removeItem('flor_auth'); setLogado(false); setDrawerOpen(false) }}
      />
    </div>
  )
}
